/* eslint-disable no-console */
/* eslint-disable react/prop-types */
import { Box, TableCell, TableRow, Tooltip } from "@mui/material";
import React, { useContext, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import NewTable from "../../member/components/Newtable/NewTable";
import styles from "../Components/EmailerTable/EmailerTable.styles";
import Typography from "../../../components/common/new/Typography/Typography";
import Button from "../../../components/common/Button";
import Emailer from "../../../services/api/emailer";
import Loader from "../../../components/common/Loader/Loader";
import { AlertStatus, PERMISSIONS } from "../../../contants";
import { ToastAlertContext } from "../../../config/providers/ToastAlert";
import { ROUTES } from "../../../utils/constants";
import { CommonStyles } from "../../../components/common/Button/commonButtonStyle";
import useUserConfig from "../../../hooks/useUserConfig";
import Alert from "../../../components/common/new/Alert/Alert";
import ReloadIcon from "../../../assets/svg/ReloadIcon";

const tabelCellWidth = {
  tiny: {
    maxWidth: "3.5rem",
  },
  small: {
    maxWidth: "6rem",
  },
  medium: {
    maxWidth: "10rem",
  },
};

const getRows = ({ searchData, currentPage, pageSize, onDelete }) => {
  if (!searchData || searchData.length === 0) {
    return (
      <TableRow style={{ padding: "8px", height: "200px" }}>
        <TableCell colSpan={6} align="center">
          <Typography
            weight={600}
            style={{
              fontSize: "18px",
              color: "#000000",
              padding: "4px",
            }}
          >
            No data available
          </Typography>
        </TableCell>
      </TableRow>
    );
  }
  return searchData.map((user, index) => {
    const serialNumber = index + 1 + currentPage * pageSize;
    return (
      <TableRow key={user?.member?.id}>
        <TableCell style={tabelCellWidth.tiny}>
          {" "}
          <Typography style={styles.typoghrphyStyle}>
            {serialNumber}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.tiny}>
          {" "}
          <Typography style={styles.typoghrphyStyle}>
            {user?.member?.id ?? user?.member?.memberId}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.small}>
          <Typography style={styles.typoghrphyStyle}>
            {user?.member?.fullName}
          </Typography>{" "}
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          <div
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            <Typography style={styles.typoghrphyStyle}>
              {user?.member?.emailId}
            </Typography>
          </div>
        </TableCell>
        <TableCell style={{ maxWidth: "12rem" }}>
          <div>
            <Typography style={styles.typoghrphyStyle}>
              {`${user?.member?.organisationStructure.areaName || "NA"} / ${
                user?.member?.organisationStructure.zoneName || "NA"
              } / ${user?.member?.organisationStructure.regionName || "NA"} / ${
                user?.member?.organisationStructure.chapterName || "NA"
              } / ${user?.member?.organisationStructure.districtName || "NA"}`}
            </Typography>{" "}
          </div>
        </TableCell>
        <TableCell>
          <Tooltip
            title="Delete"
            style={{
              cursor: "pointer",
              color: "#8c8c8c",
            }}
          >
            <DeleteOutlineOutlinedIcon
              fontSize="small"
              onClick={() => {
                onDelete(user?.id);
              }}
            />
          </Tooltip>
        </TableCell>
      </TableRow>
    );
  });
};

function ViewRecipientsTable({
  searchData,
  currentPage,
  pageSize,
  onSelectMemberForTransfer,
  onMemberStatusToggle,
  onSelectMember,
  showStatusColumn,
  totalElements,
  templateId,
  onRefresh,
}) {
  const [openAlert, setOpenAlert] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const templateInfo = useSelector((state) => state.templateInfo.templateInfo);
  const [isLoading, setIsLoading] = useState(false);
  const toast = useContext(ToastAlertContext);
  const navigate = useNavigate();
  const hasPermission = useUserConfig();
  const toggleAlert = () => setOpenAlert((prev) => !prev);

  const disableBtn = !searchData || searchData.length === 0;

  const toggleItemSelection = (itemId) => {
    if (selectedItems.includes(itemId)) {
      setSelectedItems(selectedItems.filter((id) => id !== itemId));
    } else {
      setSelectedItems([...selectedItems, itemId]);
    }
  };

  console.log("disable", disableBtn);

  const onDelete = async (id) => {
    try {
      await Emailer.deleteRecipients(templateId, id);
      toast.show("Recipient deleted Successfully", AlertStatus.SUCCESS);
      setTimeout(() => {
        onRefresh();
      }, 2000);
    } catch (error) {
      toast.show(
        "Something went wrong. Please contact support.",
        AlertStatus.ERROR
      );
    }
  };

  const handleSendEmail = async () => {
    try {
      setIsLoading(true);
      const body = {};
      const response = await Emailer.sendEmailTemplate({
        data: body,
        templateId: templateInfo.id,
      });
      if (response.code === 200) {
        toast.show("Email Sent Successfully", AlertStatus.SUCCESS);
        navigate(ROUTES.EMAILER_TEMPLATES.path);
      }
    } catch (error) {
      setIsLoading(false);
      toast.show(
        "Something went wrong. Please contact support.",
        AlertStatus.ERROR
      );
    } finally {
      setIsLoading(false);
    }
  };

  console.log("template", templateInfo);

  const onHitClear = async () => {
    try {
      setIsLoading(true);
      await Emailer.deleteAllRecipient(templateInfo.id);
      onRefresh();
      toggleAlert();
      toast.show("All Recipients Cleared Successfully", AlertStatus.SUCCESS);
    } catch (error) {
      toast.show(error.message, AlertStatus.ERROR);
    } finally {
      setIsLoading(false);
    }
  };

  const onReload = async () => {
    try {
      setIsLoading(true);
      const body = {
        notificationStatus: "PENDING",
      };
      const response = await Emailer.notificationStatusMarking({
        data: body,
        templateId: templateInfo.id,
      });
      if (response.code === 200) {
        onRefresh();
      }
    } catch (error) {
      setIsLoading(false);
      toast.show(
        "Something went wrong. Please contact support.",
        AlertStatus.ERROR
      );
    } finally {
      setIsLoading(false);
    }
  };

  const columns = [
    {
      displayName: "S.No",
      key: "s.no",
    },
    {
      displayName: "Member ID",
      key: "id",
    },
    {
      displayName: "Name",
      key: "fullName",
    },
    {
      displayName: "Email",
      key: "email",
    },
    {
      displayName: "Org Structure",
      key: "orgstructure",
    },
    {
      displayName: "Action",
      key: "action",
    },
  ];

  return (
    <div style={styles.container}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          paddingBottom: "5px",
        }}
      >
        <Box style={styles.reload} onClick={onReload}>
          <ReloadIcon />
        </Box>
      </Box>

      <Box style={styles.recipientsContainer}>
        {/* Left side - Info Fields */}
        <Box
          sx={{
            flex: "1 1 auto",
            minWidth: { xs: "100%", md: "400px" },
            maxWidth: { xs: "100%", md: "calc(100% - 380px)" },
            paddingRight: { xs: "0", md: "16px" },
          }}
        >
          <p
            style={{
              margin: "4px 0",
              fontSize: "14px",
              fontWeight: 500,
              wordWrap: "break-word",
              lineHeight: "1.5",
            }}
          >
            <strong>Template Name:</strong> {templateInfo?.templateName || "NA"}
          </p>
          <p
            style={{
              margin: "4px 0",
              fontSize: "14px",
              fontWeight: 500,
              wordWrap: "break-word",
              lineHeight: "1.5",
            }}
          >
            <strong>Email Subject:</strong> {templateInfo?.subject || "NA"}
          </p>
          <p
            style={{
              margin: "4px 0",
              fontSize: "14px",
              fontWeight: 500,
              lineHeight: "1.5",
            }}
          >
            <strong>Total Recipients:</strong> {totalElements}
          </p>
        </Box>

        {/* Right side - Buttons */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: "12px",
            alignItems: "center",
            flex: "0 0 auto",
            minWidth: { xs: "100%", md: "auto" },
          }}
        >
          {hasPermission(PERMISSIONS.DELETE_ALL_RECIPIENTS) && (
            <Button
              style={
                disableBtn
                  ? {
                      ...CommonStyles.buttonStyle,
                      width: "175px",
                      opacity: 0.7,
                      cursor: "not-allowed",
                    }
                  : {
                      ...CommonStyles.buttonStyle,
                      width: "175px",
                      "&:hover": {
                        backgroundColor: "rgb(255, 236, 240)",
                        color: "#ff1744",
                        borderColor: "#ff1744",
                      },
                    }
              }
              variant="Outlined"
              label="Clear All Recipient"
              onClick={disableBtn !== true ? toggleAlert : undefined}
            />
          )}
          {(hasPermission(PERMISSIONS.SEND_EMAIL) ||
            hasPermission(PERMISSIONS.SEND_EMAIL_BUTTON)) && (
            <Button
              style={{
                ...CommonStyles.buttonStyle,
                width: "150px",
              }}
              label="Send Email"
              disabled={disableBtn}
              onClick={handleSendEmail}
            />
          )}
        </Box>
      </Box>

      <Alert open={openAlert} onClose={toggleAlert} onSubmit={onHitClear} />
      <NewTable
        scrollable
        columns={columns}
        rows={getRows({
          searchData,
          currentPage,
          pageSize,
          onSelectMemberForTransfer,
          onSelectMember,
          onMemberStatusToggle,
          showStatusColumn,
          selectedItems,
          toggleItemSelection,
          onDelete,
        })}
        tableBodyTheme="#F6F6F6"
        tableHeadCellStyle={{ ...styles.tableHeadCells, textAlign: "left" }}
      />
      {isLoading && <Loader />}
    </div>
  );
}

export default ViewRecipientsTable;
